import { Parts } from '../types'

/**
 * 웹파트 드레그 시작 시 대상 엘리먼트 확인
 * 웹 파트 내의 하위 엘리먼트를 잡고 그레그할 경우, 웹파트 전체 크기를 알 수 없기 때문에
 * 웹파트를 감싸고 있는 컨테이너 영역을 찾는다.
 * 검색 실패시 오류를 발생시킨다.
 * @param el Event.target Element
 */
export function ensureTargetElement(el: HTMLElement): HTMLElement {
    const className = 'part'
    if (el.classList.contains(className)) {
        return el
    } else {
        const found = el.closest('.' + className)
        if (found) return found as HTMLElement
        else {
            const message = `Failed to find parent element using selector '.${className}'.`
            throw new Error(message)
        }
    }
}

export function moveParts(array: Parts, from: number, to: number) {
    console.log('moveParts', from, ' to ', to)
    // var newarr = [...array]
    // newarr.splice(to, 0, newarr.splice(from, 1)[0])
    array.splice(to, 0, array.splice(from, 1)[0])
    return array // for testing
}
